import React from 'react'

const Navbar = () => {
  return (
    <div className='navbar'>
      <a href='#hero' className='nav-logo'>Portfolio</a>

      <div className='nav-headers'>
        <a href='#about'>About</a>
        <a href='#approach'>Approach</a>
        <a href='#projects'>Projects</a>
        <a href='#contact'>Contact Me</a>
      </div>

      <div className='nav-mob'>
        <button>
          Menu
        </button>
      </div>
    </div>
  )
}

export default Navbar;
